// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/content.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OperationResult, PageRequest, PageResponse, RequestMetadata } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { CreatePlaybackGrantResponse, LiveRoom } from "./live_pb";
import { file_live178_v1_live } from "./live_pb";
import type { Match, SportType } from "./sports_pb";
import { file_live178_v1_sports } from "./sports_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/content.proto.
 */
export const file_live178_v1_content: GenFile = /*@__PURE__*/
  fileDesc("ChhsaXZlMTc4L3YxL2NvbnRlbnQucHJvdG8SCmxpdmUxNzgudjEihQEKBkJhbm5lchIRCgliYW5uZXJfaWQYASABKAkSDQoFdGl0bGUYAiABKAkSEQoJaW1hZ2VfdXJsGAMgASgJEhIKCnRhcmdldF91cmwYBCABKAkSGwoTYWNjZXNzaWJpbGl0eV9sYWJlbBgFIAEoCRIVCg1kaXNwbGF5X29yZGVyGAYgASgFIrkBChBBcHBBZHZlcnRpc2VtZW50EhgKEGFkdmVydGlzZW1lbnRfaWQYASABKAkSDQoFdGl0bGUYAiABKAkSEQoJaW1hZ2VfdXJsGAMgASgJEhIKCnRhcmdldF91cmwYBCABKAkSLQoJcGxhY2VtZW50GAUgASgOMhoubGl2ZTE3OC52MS5BcHBBZFBsYWNlbWVudBIPCgdlbmFibGVkGAYgASgIEhUKDWRpc3BsYXlfb3JkZXIYByABKAUi/wEKCUFwcENvbmZpZxIQCghhcHBfbmFtZRgBIAEoCRIQCghsb2dvX3VybBgCIAEoCRIdChVoZWFkZXJfYmFja2dyb3VuZF91cmwYAyABKAkSFAoMYW5ub3VuY2VtZW50GAQgASgJEiEKGWhvbWVfcmVjb21tZW5kYXRpb25fdGl0bGUYBSABKAkSNAoOYWR2ZXJ0aXNlbWVudHMYBiADKAsyHC5saXZlMTc4LnYxLkFwcEFkdmVydGlzZW1lbnQSLgoKdXBkYXRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIcmV2aXNpb24YCCABKAMivQIKB0FydGljbGUSEgoKYXJ0aWNsZV9pZBgBIAEoCRISCgpjaGFubmVsX2lkGAIgASgJEg0KBXRpdGxlGAMgASgJEg8KB3N1bW1hcnkYBCABKAkSEQoJYm9keV9odG1sGAUgASgJEhEKCWNvdmVyX3VybBgGIAEoCRITCgtzb3VyY2VfbmFtZRgHIAEoCRIYChByaWdodHNfcmVmZXJlbmNlGAggASgJEi0KBnN0YXR1cxgJIAEoDjIdLmxpdmUxNzgudjEuUHVibGljYXRpb25TdGF0dXMSMAoMcHVibGlzaGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI0ChByaWdodHNfZXhwaXJlX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKsAgoFVmlkZW8SEAoIdmlkZW9faWQYASABKAkSDQoFdGl0bGUYAiABKAkSDwoHc3VtbWFyeRgDIAEoCRIRCgljb3Zlcl91cmwYBCABKAkSGAoQZHVyYXRpb25fc2Vjb25kcxgFIAEoAxIZChFwbGF5YmFja19hc3NldF9pZBgGIAEoCRItCgZzdGF0dXMYByABKA4yHS5saXZlMTc4LnYxLlB1YmxpY2F0aW9uU3RhdHVzEjAKDHB1Ymxpc2hlZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASNAoQcmlnaHRzX2V4cGlyZV9hdBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKY2hhbm5lbF9pZBgKIAEoCSI2Cg5HZXRIb21lUmVxdWVzdBIkCgVzcG9ydBgBIAEoDjIVLmxpdmUxNzgudjEuU3BvcnRUeXBlIvMBCg9HZXRIb21lUmVzcG9uc2USIwoHYmFubmVycxgBIAMoCzISLmxpdmUxNzgudjEuQmFubmVyEisKEGZlYXR1cmVkX21hdGNoZXMYAiADKAsyES5saXZlMTc4LnYxLk1hdGNoEjEKE2ZlYXR1cmVkX2xpdmVfcm9vbXMYAyADKAsyFC5saXZlMTc4LnYxLkxpdmVSb29tEiwKD2xhdGVzdF9hcnRpY2xlcxgEIAMoCzITLmxpdmUxNzgudjEuQXJ0aWNsZRItCghtZXRhZGF0YRgFIAEoCzIbLmxpdmUxNzgudjEuUmVxdWVzdE1ldGFkYXRhIhUKE0dldEFwcENvbmZpZ1JlcXVlc3QiPQoUR2V0QXBwQ29uZmlnUmVzcG9uc2USJQoGY29uZmlnGAEgASgLMhUubGl2ZTE3OC52MS5BcHBDb25maWciUAoTTGlzdEFydGljbGVzUmVxdWVzdBISCgpjaGFubmVsX2lkGAEgASgJEiUKBHBhZ2UYAiABKAsyFy5saXZlMTc4LnYxLlBhZ2VSZXF1ZXN0ImUKFExpc3RBcnRpY2xlc1Jlc3BvbnNlEiUKCGFydGljbGVzGAEgAygLMhMubGl2ZTE3OC52MS5BcnRpY2xlEiYKBHBhZ2UYAiABKAsyGC5saXZlMTc4LnYxLlBhZ2VSZXNwb25zZSInChFHZXRBcnRpY2xlUmVxdWVzdBISCgphcnRpY2xlX2lkGAEgASgJIjoKEkdldEFydGljbGVSZXNwb25zZRIkCgdhcnRpY2xlGAEgASgLMhMubGl2ZTE3OC52MS5BcnRpY2xlIk4KEUxpc3RWaWRlb3NSZXF1ZXN0EhIKCmNoYW5uZWxfaWQYASABKAkSJQoEcGFnZRgCIAEoCzIXLmxpdmUxNzgudjEuUGFnZVJlcXVlc3QiXwoSTGlzdFZpZGVvc1Jlc3BvbnNlEiEKBnZpZGVvcxgBIAMoCzIRLmxpdmUxNzgudjEuVmlkZW8SJgoEcGFnZRgCIAEoCzIYLmxpdmUxNzgudjEuUGFnZVJlc3BvbnNlIiMKD0dldFZpZGVvUmVxdWVzdBIQCgh2aWRlb19pZBgBIAEoCSJvChBHZXRWaWRlb1Jlc3BvbnNlEiAKBXZpZGVvGAEgASgLMhEubGl2ZTE3OC52MS5WaWRlbxI5CghwbGF5YmFjaxgCIAEoCzInLmxpdmUxNzgudjEuQ3JlYXRlUGxheWJhY2tHcmFudFJlc3BvbnNlIlQKDVNlYXJjaFJlcXVlc3QSDQoFcXVlcnkYASABKAkSDQoFdHlwZXMYAiADKAkSJQoEcGFnZRgDIAEoCzIXLmxpdmUxNzgudjEuUGFnZVJlcXVlc3QiewoJU2VhcmNoSGl0EgwKBHR5cGUYASABKAkSCgoCaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSDwoHc3VtbWFyeRgEIAEoCRIRCglpbWFnZV91cmwYBSABKAkSEgoKdGFyZ2V0X3VybBgGIAEoCRINCgVzY29yZRgHIAEoASJyCg5TZWFyY2hSZXNwb25zZRIjCgRoaXRzGAEgAygLMhUubGl2ZTE3OC52MS5TZWFyY2hIaXQSEwoLc3VnZ2VzdGlvbnMYAiADKAkSJgoEcGFnZRgDIAEoCzIYLmxpdmUxNzgudjEuUGFnZVJlc3BvbnNlIk4KElNldEZhdm9yaXRlUmVxdWVzdBITCgtlbnRpdHlfdHlwZRgBIAEoCRIRCgllbnRpdHlfaWQYAiABKAkSEAoIZmF2b3JpdGUYAyABKAgiQgoTU2V0RmF2b3JpdGVSZXNwb25zZRIrCgZyZXN1bHQYASABKAsyGy5saXZlMTc4LnYxLk9wZXJhdGlvblJlc3VsdCqlAgoRUHVibGljYXRpb25TdGF0dXMSIgoeUFVCTElDQVRJT05fU1RBVFVTX1VOU1BFQ0lGSUVEEAASHAoYUFVCTElDQVRJT05fU1RBVFVTX0RSQUZUEAESJwojUFVCTElDQVRJT05fU1RBVFVTX1JFVklFV19SRVFVRVNURUQQAhIfChtQVUJMSUNBVElPTl9TVEFUVVNfQVBQUk9WRUQQAxIgChxQVUJMSUNBVElPTl9TVEFUVVNfU0NIRURVTEVEEAQSIAocUFVCTElDQVRJT05fU1RBVFVTX1BVQkxJU0hFRBAFEiAKHFBVQkxJQ0FUSU9OX1NUQVRVU19XSVRIRFJBV04QBhIeChpQVUJMSUNBVElPTl9TVEFUVVNfRVhQSVJFRBAHKpUBCg5BcHBBZFBsYWNlbWVudBIgChxBUFBfQURfUExBQ0VNRU5UX1VOU1BFQ0lGSUVEEAASIgoeQVBQX0FEX1BMQUNFTUVOVF9IT01FX0NBUk9VU0VMEAESIAocQVBQX0FEX1BMQUNFTUVOVF9MSVZFX0hFQURFUhACEhsKF0FQUF9BRF9QTEFDRU1FTlRfU1BMQVNIEAMy7AQKDkNvbnRlbnRTZXJ2aWNlElEKDEdldEFwcENvbmZpZxIfLmxpdmUxNzgudjEuR2V0QXBwQ29uZmlnUmVxdWVzdBogLmxpdmUxNzgudjEuR2V0QXBwQ29uZmlnUmVzcG9uc2USQgoHR2V0SG9tZRIaLmxpdmUxNzgudjEuR2V0SG9tZVJlcXVlc3QaGy5saXZlMTc4LnYxLkdldEhvbWVSZXNwb25zZRJRCgxMaXN0QXJ0aWNsZXMSHy5saXZlMTc4LnYxLkxpc3RBcnRpY2xlc1JlcXVlc3QaIC5saXZlMTc4LnYxLkxpc3RBcnRpY2xlc1Jlc3BvbnNlEksKCkdldEFydGljbGUSHS5saXZlMTc4LnYxLkdldEFydGljbGVSZXF1ZXN0Gh4ubGl2ZTE3OC52MS5HZXRBcnRpY2xlUmVzcG9uc2USSwoKTGlzdFZpZGVvcxIdLmxpdmUxNzgudjEuTGlzdFZpZGVvc1JlcXVlc3QaHi5saXZlMTc4LnYxLkxpc3RWaWRlb3NSZXNwb25zZRJFCghHZXRWaWRlbxIbLmxpdmUxNzgudjEuR2V0VmlkZW9SZXF1ZXN0GhwubGl2ZTE3OC52MS5HZXRWaWRlb1Jlc3BvbnNlEj8KBlNlYXJjaBIZLmxpdmUxNzgudjEuU2VhcmNoUmVxdWVzdBoaLmxpdmUxNzgudjEuU2VhcmNoUmVzcG9uc2USTgoLU2V0RmF2b3JpdGUSHi5saXZlMTc4LnYxLlNldEZhdm9yaXRlUmVxdWVzdBofLmxpdmUxNzgudjEuU2V0RmF2b3JpdGVSZXNwb25zZUI5WjdnaXRodWIuY29tL2xpdmUxNzgvcGxhdGZvcm0vZ2VuL2dvL2xpdmUxNzgvdjE7bGl2ZTE3OHYxYgZwcm90bzM", [file_google_protobuf_timestamp, file_live178_v1_common, file_live178_v1_live, file_live178_v1_sports]);

/**
 * @generated from message live178.v1.Banner
 */
export type Banner = Message<"live178.v1.Banner"> & {
  /**
   * @generated from field: string banner_id = 1;
   */
  bannerId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;

  /**
   * @generated from field: string target_url = 4;
   */
  targetUrl: string;

  /**
   * @generated from field: string accessibility_label = 5;
   */
  accessibilityLabel: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;
};

/**
 * Describes the message live178.v1.Banner.
 * Use `create(BannerSchema)` to create a new message.
 */
export const BannerSchema: GenMessage<Banner> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 0);

/**
 * @generated from message live178.v1.AppAdvertisement
 */
export type AppAdvertisement = Message<"live178.v1.AppAdvertisement"> & {
  /**
   * @generated from field: string advertisement_id = 1;
   */
  advertisementId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;

  /**
   * @generated from field: string target_url = 4;
   */
  targetUrl: string;

  /**
   * @generated from field: live178.v1.AppAdPlacement placement = 5;
   */
  placement: AppAdPlacement;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 display_order = 7;
   */
  displayOrder: number;
};

/**
 * Describes the message live178.v1.AppAdvertisement.
 * Use `create(AppAdvertisementSchema)` to create a new message.
 */
export const AppAdvertisementSchema: GenMessage<AppAdvertisement> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 1);

/**
 * @generated from message live178.v1.AppConfig
 */
export type AppConfig = Message<"live178.v1.AppConfig"> & {
  /**
   * @generated from field: string app_name = 1;
   */
  appName: string;

  /**
   * @generated from field: string logo_url = 2;
   */
  logoUrl: string;

  /**
   * @generated from field: string header_background_url = 3;
   */
  headerBackgroundUrl: string;

  /**
   * @generated from field: string announcement = 4;
   */
  announcement: string;

  /**
   * @generated from field: string home_recommendation_title = 5;
   */
  homeRecommendationTitle: string;

  /**
   * @generated from field: repeated live178.v1.AppAdvertisement advertisements = 6;
   */
  advertisements: AppAdvertisement[];

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 8;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.AppConfig.
 * Use `create(AppConfigSchema)` to create a new message.
 */
export const AppConfigSchema: GenMessage<AppConfig> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 2);

/**
 * @generated from message live178.v1.Article
 */
export type Article = Message<"live178.v1.Article"> & {
  /**
   * @generated from field: string article_id = 1;
   */
  articleId: string;

  /**
   * @generated from field: string channel_id = 2;
   */
  channelId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string summary = 4;
   */
  summary: string;

  /**
   * @generated from field: string body_html = 5;
   */
  bodyHtml: string;

  /**
   * @generated from field: string cover_url = 6;
   */
  coverUrl: string;

  /**
   * @generated from field: string source_name = 7;
   */
  sourceName: string;

  /**
   * @generated from field: string rights_reference = 8;
   */
  rightsReference: string;

  /**
   * @generated from field: live178.v1.PublicationStatus status = 9;
   */
  status: PublicationStatus;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 10;
   */
  publishedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp rights_expire_at = 11;
   */
  rightsExpireAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.Article.
 * Use `create(ArticleSchema)` to create a new message.
 */
export const ArticleSchema: GenMessage<Article> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 3);

/**
 * @generated from message live178.v1.Video
 */
export type Video = Message<"live178.v1.Video"> & {
  /**
   * @generated from field: string video_id = 1;
   */
  videoId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string summary = 3;
   */
  summary: string;

  /**
   * @generated from field: string cover_url = 4;
   */
  coverUrl: string;

  /**
   * @generated from field: int64 duration_seconds = 5;
   */
  durationSeconds: bigint;

  /**
   * @generated from field: string playback_asset_id = 6;
   */
  playbackAssetId: string;

  /**
   * @generated from field: live178.v1.PublicationStatus status = 7;
   */
  status: PublicationStatus;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 8;
   */
  publishedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp rights_expire_at = 9;
   */
  rightsExpireAt?: Timestamp | undefined;

  /**
   * @generated from field: string channel_id = 10;
   */
  channelId: string;
};

/**
 * Describes the message live178.v1.Video.
 * Use `create(VideoSchema)` to create a new message.
 */
export const VideoSchema: GenMessage<Video> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 4);

/**
 * @generated from message live178.v1.GetHomeRequest
 */
export type GetHomeRequest = Message<"live178.v1.GetHomeRequest"> & {
  /**
   * @generated from field: live178.v1.SportType sport = 1;
   */
  sport: SportType;
};

/**
 * Describes the message live178.v1.GetHomeRequest.
 * Use `create(GetHomeRequestSchema)` to create a new message.
 */
export const GetHomeRequestSchema: GenMessage<GetHomeRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 5);

/**
 * @generated from message live178.v1.GetHomeResponse
 */
export type GetHomeResponse = Message<"live178.v1.GetHomeResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Banner banners = 1;
   */
  banners: Banner[];

  /**
   * @generated from field: repeated live178.v1.Match featured_matches = 2;
   */
  featuredMatches: Match[];

  /**
   * @generated from field: repeated live178.v1.LiveRoom featured_live_rooms = 3;
   */
  featuredLiveRooms: LiveRoom[];

  /**
   * @generated from field: repeated live178.v1.Article latest_articles = 4;
   */
  latestArticles: Article[];

  /**
   * @generated from field: live178.v1.RequestMetadata metadata = 5;
   */
  metadata?: RequestMetadata | undefined;
};

/**
 * Describes the message live178.v1.GetHomeResponse.
 * Use `create(GetHomeResponseSchema)` to create a new message.
 */
export const GetHomeResponseSchema: GenMessage<GetHomeResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 6);

/**
 * @generated from message live178.v1.GetAppConfigRequest
 */
export type GetAppConfigRequest = Message<"live178.v1.GetAppConfigRequest"> & {
};

/**
 * Describes the message live178.v1.GetAppConfigRequest.
 * Use `create(GetAppConfigRequestSchema)` to create a new message.
 */
export const GetAppConfigRequestSchema: GenMessage<GetAppConfigRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 7);

/**
 * @generated from message live178.v1.GetAppConfigResponse
 */
export type GetAppConfigResponse = Message<"live178.v1.GetAppConfigResponse"> & {
  /**
   * @generated from field: live178.v1.AppConfig config = 1;
   */
  config?: AppConfig | undefined;
};

/**
 * Describes the message live178.v1.GetAppConfigResponse.
 * Use `create(GetAppConfigResponseSchema)` to create a new message.
 */
export const GetAppConfigResponseSchema: GenMessage<GetAppConfigResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 8);

/**
 * @generated from message live178.v1.ListArticlesRequest
 */
export type ListArticlesRequest = Message<"live178.v1.ListArticlesRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListArticlesRequest.
 * Use `create(ListArticlesRequestSchema)` to create a new message.
 */
export const ListArticlesRequestSchema: GenMessage<ListArticlesRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 9);

/**
 * @generated from message live178.v1.ListArticlesResponse
 */
export type ListArticlesResponse = Message<"live178.v1.ListArticlesResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Article articles = 1;
   */
  articles: Article[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListArticlesResponse.
 * Use `create(ListArticlesResponseSchema)` to create a new message.
 */
export const ListArticlesResponseSchema: GenMessage<ListArticlesResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 10);

/**
 * @generated from message live178.v1.GetArticleRequest
 */
export type GetArticleRequest = Message<"live178.v1.GetArticleRequest"> & {
  /**
   * @generated from field: string article_id = 1;
   */
  articleId: string;
};

/**
 * Describes the message live178.v1.GetArticleRequest.
 * Use `create(GetArticleRequestSchema)` to create a new message.
 */
export const GetArticleRequestSchema: GenMessage<GetArticleRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 11);

/**
 * @generated from message live178.v1.GetArticleResponse
 */
export type GetArticleResponse = Message<"live178.v1.GetArticleResponse"> & {
  /**
   * @generated from field: live178.v1.Article article = 1;
   */
  article?: Article | undefined;
};

/**
 * Describes the message live178.v1.GetArticleResponse.
 * Use `create(GetArticleResponseSchema)` to create a new message.
 */
export const GetArticleResponseSchema: GenMessage<GetArticleResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 12);

/**
 * @generated from message live178.v1.ListVideosRequest
 */
export type ListVideosRequest = Message<"live178.v1.ListVideosRequest"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListVideosRequest.
 * Use `create(ListVideosRequestSchema)` to create a new message.
 */
export const ListVideosRequestSchema: GenMessage<ListVideosRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 13);

/**
 * @generated from message live178.v1.ListVideosResponse
 */
export type ListVideosResponse = Message<"live178.v1.ListVideosResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Video videos = 1;
   */
  videos: Video[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListVideosResponse.
 * Use `create(ListVideosResponseSchema)` to create a new message.
 */
export const ListVideosResponseSchema: GenMessage<ListVideosResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 14);

/**
 * @generated from message live178.v1.GetVideoRequest
 */
export type GetVideoRequest = Message<"live178.v1.GetVideoRequest"> & {
  /**
   * @generated from field: string video_id = 1;
   */
  videoId: string;
};

/**
 * Describes the message live178.v1.GetVideoRequest.
 * Use `create(GetVideoRequestSchema)` to create a new message.
 */
export const GetVideoRequestSchema: GenMessage<GetVideoRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 15);

/**
 * @generated from message live178.v1.GetVideoResponse
 */
export type GetVideoResponse = Message<"live178.v1.GetVideoResponse"> & {
  /**
   * @generated from field: live178.v1.Video video = 1;
   */
  video?: Video | undefined;

  /**
   * @generated from field: live178.v1.CreatePlaybackGrantResponse playback = 2;
   */
  playback?: CreatePlaybackGrantResponse | undefined;
};

/**
 * Describes the message live178.v1.GetVideoResponse.
 * Use `create(GetVideoResponseSchema)` to create a new message.
 */
export const GetVideoResponseSchema: GenMessage<GetVideoResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 16);

/**
 * @generated from message live178.v1.SearchRequest
 */
export type SearchRequest = Message<"live178.v1.SearchRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: repeated string types = 2;
   */
  types: string[];

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 17);

/**
 * @generated from message live178.v1.SearchHit
 */
export type SearchHit = Message<"live178.v1.SearchHit"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string summary = 4;
   */
  summary: string;

  /**
   * @generated from field: string image_url = 5;
   */
  imageUrl: string;

  /**
   * @generated from field: string target_url = 6;
   */
  targetUrl: string;

  /**
   * @generated from field: double score = 7;
   */
  score: number;
};

/**
 * Describes the message live178.v1.SearchHit.
 * Use `create(SearchHitSchema)` to create a new message.
 */
export const SearchHitSchema: GenMessage<SearchHit> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 18);

/**
 * @generated from message live178.v1.SearchResponse
 */
export type SearchResponse = Message<"live178.v1.SearchResponse"> & {
  /**
   * @generated from field: repeated live178.v1.SearchHit hits = 1;
   */
  hits: SearchHit[];

  /**
   * @generated from field: repeated string suggestions = 2;
   */
  suggestions: string[];

  /**
   * @generated from field: live178.v1.PageResponse page = 3;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 19);

/**
 * @generated from message live178.v1.SetFavoriteRequest
 */
export type SetFavoriteRequest = Message<"live178.v1.SetFavoriteRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: bool favorite = 3;
   */
  favorite: boolean;
};

/**
 * Describes the message live178.v1.SetFavoriteRequest.
 * Use `create(SetFavoriteRequestSchema)` to create a new message.
 */
export const SetFavoriteRequestSchema: GenMessage<SetFavoriteRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 20);

/**
 * @generated from message live178.v1.SetFavoriteResponse
 */
export type SetFavoriteResponse = Message<"live178.v1.SetFavoriteResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.SetFavoriteResponse.
 * Use `create(SetFavoriteResponseSchema)` to create a new message.
 */
export const SetFavoriteResponseSchema: GenMessage<SetFavoriteResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_content, 21);

/**
 * @generated from enum live178.v1.PublicationStatus
 */
export enum PublicationStatus {
  /**
   * @generated from enum value: PUBLICATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLICATION_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: PUBLICATION_STATUS_REVIEW_REQUESTED = 2;
   */
  REVIEW_REQUESTED = 2,

  /**
   * @generated from enum value: PUBLICATION_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: PUBLICATION_STATUS_SCHEDULED = 4;
   */
  SCHEDULED = 4,

  /**
   * @generated from enum value: PUBLICATION_STATUS_PUBLISHED = 5;
   */
  PUBLISHED = 5,

  /**
   * @generated from enum value: PUBLICATION_STATUS_WITHDRAWN = 6;
   */
  WITHDRAWN = 6,

  /**
   * @generated from enum value: PUBLICATION_STATUS_EXPIRED = 7;
   */
  EXPIRED = 7,
}

/**
 * Describes the enum live178.v1.PublicationStatus.
 */
export const PublicationStatusSchema: GenEnum<PublicationStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_content, 0);

/**
 * @generated from enum live178.v1.AppAdPlacement
 */
export enum AppAdPlacement {
  /**
   * @generated from enum value: APP_AD_PLACEMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APP_AD_PLACEMENT_HOME_CAROUSEL = 1;
   */
  HOME_CAROUSEL = 1,

  /**
   * @generated from enum value: APP_AD_PLACEMENT_LIVE_HEADER = 2;
   */
  LIVE_HEADER = 2,

  /**
   * @generated from enum value: APP_AD_PLACEMENT_SPLASH = 3;
   */
  SPLASH = 3,
}

/**
 * Describes the enum live178.v1.AppAdPlacement.
 */
export const AppAdPlacementSchema: GenEnum<AppAdPlacement> = /*@__PURE__*/
  enumDesc(file_live178_v1_content, 1);

/**
 * @generated from service live178.v1.ContentService
 */
export const ContentService: GenService<{
  /**
   * @generated from rpc live178.v1.ContentService.GetAppConfig
   */
  getAppConfig: {
    methodKind: "unary";
    input: typeof GetAppConfigRequestSchema;
    output: typeof GetAppConfigResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.GetHome
   */
  getHome: {
    methodKind: "unary";
    input: typeof GetHomeRequestSchema;
    output: typeof GetHomeResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.ListArticles
   */
  listArticles: {
    methodKind: "unary";
    input: typeof ListArticlesRequestSchema;
    output: typeof ListArticlesResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.GetArticle
   */
  getArticle: {
    methodKind: "unary";
    input: typeof GetArticleRequestSchema;
    output: typeof GetArticleResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.ListVideos
   */
  listVideos: {
    methodKind: "unary";
    input: typeof ListVideosRequestSchema;
    output: typeof ListVideosResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.GetVideo
   */
  getVideo: {
    methodKind: "unary";
    input: typeof GetVideoRequestSchema;
    output: typeof GetVideoResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.ContentService.SetFavorite
   */
  setFavorite: {
    methodKind: "unary";
    input: typeof SetFavoriteRequestSchema;
    output: typeof SetFavoriteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_content, 0);

